// Auto-generated z cviky_databaze.csv (29.5.2026). Edit původ CSV, ne tento soubor.
// Read-only katalog 169 cviků pro autocomplete v Tréninkovém profilu klienta.
// Search lokální (in-memory), žádný API call.

export const CVIKY_DATABAZE = [
  {
    "id": 1,
    "nazev": "Dřep s vlastní vahou",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy, hýždě",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 2,
    "nazev": "Goblet dřep",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy, hýždě",
    "vybaveni": "Kettlebell / jednoručka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 3,
    "nazev": "Dřep u zdi (wall sit)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 4,
    "nazev": "Dřep na Smith stroji",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy, hýždě",
    "vybaveni": "Smith stroj",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 5,
    "nazev": "Box squat",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy, hýždě",
    "vybaveni": "Velká osa / lavice",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 6,
    "nazev": "Dřep s velkou osou (back squat)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy, hýždě, core",
    "vybaveni": "Velká osa",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 7,
    "nazev": "Front squat (čelní dřep)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy, core",
    "vybaveni": "Velká osa",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 8,
    "nazev": "Sumo dřep",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy, adduktory, hýždě",
    "vybaveni": "Velká osa / kettlebell",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 9,
    "nazev": "Hack dřep",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy",
    "vybaveni": "Stroj",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 10,
    "nazev": "Leg press (tlak nohama)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy, hýždě",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 11,
    "nazev": "Předkopávání (leg extension)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Izolace",
    "svaly": "Kvadricepsy",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 12,
    "nazev": "Sissy dřep",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy",
    "vybaveni": "Vlastní váha",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 13,
    "nazev": "Výpady na místě",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Výpad",
    "svaly": "Kvadricepsy, hýždě",
    "vybaveni": "Vlastní váha / jednoručky",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 14,
    "nazev": "Výpady v chůzi",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Výpad",
    "svaly": "Kvadricepsy, hýždě",
    "vybaveni": "Vlastní váha / jednoručky",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 15,
    "nazev": "Boční výpady",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Výpad",
    "svaly": "Kvadricepsy, adduktory, hýždě",
    "vybaveni": "Vlastní váha / jednoručky",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 16,
    "nazev": "Bulharský dřep (split squat)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Výpad",
    "svaly": "Kvadricepsy, hýždě",
    "vybaveni": "Jednoručky / lavice",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 17,
    "nazev": "Výstupy na bednu (step-up)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Výpad",
    "svaly": "Kvadricepsy, hýždě",
    "vybaveni": "Bedna / jednoručky",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 18,
    "nazev": "Cossack squat",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Výpad",
    "svaly": "Adduktory, kvadricepsy",
    "vybaveni": "Vlastní váha",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 19,
    "nazev": "Pistol squat (dřep na jedné)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy, hýždě",
    "vybaveni": "Vlastní váha",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 20,
    "nazev": "Hip thrust",
    "kategorie": "Hýždě",
    "pohybVzor": "Hip hinge",
    "svaly": "Hýždě, hamstringy",
    "vybaveni": "Velká osa / lavice",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 21,
    "nazev": "Glute bridge (most)",
    "kategorie": "Hýždě",
    "pohybVzor": "Hip hinge",
    "svaly": "Hýždě, hamstringy",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 22,
    "nazev": "Glute bridge jednonož",
    "kategorie": "Hýždě",
    "pohybVzor": "Hip hinge",
    "svaly": "Hýždě, hamstringy",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 23,
    "nazev": "Mrtvý tah (deadlift)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Hip hinge",
    "svaly": "Hamstringy, hýždě, záda",
    "vybaveni": "Velká osa",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 24,
    "nazev": "Rumunský mrtvý tah (RDL)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Hip hinge",
    "svaly": "Hamstringy, hýždě",
    "vybaveni": "Velká osa / jednoručky",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 25,
    "nazev": "Mrtvý tah s jednoručkami",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Hip hinge",
    "svaly": "Hamstringy, hýždě",
    "vybaveni": "Jednoručky",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 26,
    "nazev": "Mrtvý tah jednonož (single-leg RDL)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Hip hinge",
    "svaly": "Hamstringy, hýždě, stabilizace",
    "vybaveni": "Jednoručka",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 27,
    "nazev": "Kettlebell swing",
    "kategorie": "Komplexní",
    "pohybVzor": "Hip hinge",
    "svaly": "Hýždě, hamstringy, core",
    "vybaveni": "Kettlebell",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 28,
    "nazev": "Good morning",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Hip hinge",
    "svaly": "Hamstringy, vzpřimovače",
    "vybaveni": "Velká osa",
    "obtiznost": 3,
    "bolestiZad": "Ne\r"
  },
  {
    "id": 29,
    "nazev": "Cable pull-through",
    "kategorie": "Hýždě",
    "pohybVzor": "Hip hinge",
    "svaly": "Hýždě, hamstringy",
    "vybaveni": "Kladka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 30,
    "nazev": "Zakopávání vleže (leg curl)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Izolace",
    "svaly": "Hamstringy",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 31,
    "nazev": "Zakopávání vsedě (seated leg curl)",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Izolace",
    "svaly": "Hamstringy",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 32,
    "nazev": "Nordic hamstring curl",
    "kategorie": "Dolní končetiny",
    "pohybVzor": "Izolace",
    "svaly": "Hamstringy",
    "vybaveni": "Vlastní váha",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 33,
    "nazev": "Hyperextenze (zádový stroj)",
    "kategorie": "Záda",
    "pohybVzor": "Hip hinge",
    "svaly": "Vzpřimovače, hýždě",
    "vybaveni": "Hyperextenzní lavice",
    "obtiznost": 1,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 34,
    "nazev": "Zakopávání na kladce (kickback)",
    "kategorie": "Hýždě",
    "pohybVzor": "Izolace",
    "svaly": "Hýždě",
    "vybaveni": "Kladka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 35,
    "nazev": "Abdukce na stroji (sed)",
    "kategorie": "Hýždě",
    "pohybVzor": "Izolace",
    "svaly": "Hýždě (m. gluteus medius)",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 36,
    "nazev": "Abdukce s gumou (clamshell)",
    "kategorie": "Hýždě",
    "pohybVzor": "Izolace",
    "svaly": "Hýždě (m. gluteus medius)",
    "vybaveni": "Odporová guma",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 37,
    "nazev": "Donkey kicks",
    "kategorie": "Hýždě",
    "pohybVzor": "Izolace",
    "svaly": "Hýždě",
    "vybaveni": "Vlastní váha / guma",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 38,
    "nazev": "Lateral band walk",
    "kategorie": "Hýždě",
    "pohybVzor": "Izolace",
    "svaly": "Hýždě (m. gluteus medius)",
    "vybaveni": "Odporová guma",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 39,
    "nazev": "Monster walk",
    "kategorie": "Hýždě",
    "pohybVzor": "Izolace",
    "svaly": "Hýždě",
    "vybaveni": "Odporová guma",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 40,
    "nazev": "Výpony ve stoje",
    "kategorie": "Lýtka",
    "pohybVzor": "Izolace",
    "svaly": "Lýtka (m. gastrocnemius)",
    "vybaveni": "Vlastní váha / stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 41,
    "nazev": "Výpony vsedě",
    "kategorie": "Lýtka",
    "pohybVzor": "Izolace",
    "svaly": "Lýtka (m. soleus)",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 42,
    "nazev": "Výpony na leg pressu",
    "kategorie": "Lýtka",
    "pohybVzor": "Izolace",
    "svaly": "Lýtka",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 43,
    "nazev": "Výpony jednonož",
    "kategorie": "Lýtka",
    "pohybVzor": "Izolace",
    "svaly": "Lýtka",
    "vybaveni": "Vlastní váha / jednoručka",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 44,
    "nazev": "Tibialis raise (přední holeň)",
    "kategorie": "Lýtka",
    "pohybVzor": "Izolace",
    "svaly": "M. tibialis anterior",
    "vybaveni": "Vlastní váha / guma",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 45,
    "nazev": "Stahování horní kladky (lat pulldown)",
    "kategorie": "Záda",
    "pohybVzor": "Tah vertikální",
    "svaly": "Široký sval zádový, biceps",
    "vybaveni": "Kladka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 46,
    "nazev": "Stahování horní kladky úzký úchop",
    "kategorie": "Záda",
    "pohybVzor": "Tah vertikální",
    "svaly": "Široký sval zádový, biceps",
    "vybaveni": "Kladka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 47,
    "nazev": "Stahování horní kladky podhmatem",
    "kategorie": "Záda",
    "pohybVzor": "Tah vertikální",
    "svaly": "Široký sval zádový, biceps",
    "vybaveni": "Kladka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 48,
    "nazev": "Shyby (pull-up)",
    "kategorie": "Záda",
    "pohybVzor": "Tah vertikální",
    "svaly": "Široký sval zádový, biceps",
    "vybaveni": "Hrazda",
    "obtiznost": 3,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 49,
    "nazev": "Shyby podhmatem (chin-up)",
    "kategorie": "Záda",
    "pohybVzor": "Tah vertikální",
    "svaly": "Široký sval zádový, biceps",
    "vybaveni": "Hrazda",
    "obtiznost": 3,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 50,
    "nazev": "Asistované shyby (stroj/guma)",
    "kategorie": "Záda",
    "pohybVzor": "Tah vertikální",
    "svaly": "Široký sval zádový, biceps",
    "vybaveni": "Stroj / guma",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 51,
    "nazev": "Straight-arm pulldown",
    "kategorie": "Záda",
    "pohybVzor": "Izolace",
    "svaly": "Široký sval zádový",
    "vybaveni": "Kladka",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 52,
    "nazev": "Veslování s velkou osou (předklon)",
    "kategorie": "Záda",
    "pohybVzor": "Tah horizontální",
    "svaly": "Záda, biceps, zadní delty",
    "vybaveni": "Velká osa",
    "obtiznost": 3,
    "bolestiZad": "Ne\r"
  },
  {
    "id": 53,
    "nazev": "Veslování s jednoručkou (předklon)",
    "kategorie": "Záda",
    "pohybVzor": "Tah horizontální",
    "svaly": "Záda, biceps",
    "vybaveni": "Jednoručka / lavice",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 54,
    "nazev": "Veslování na spodní kladce (sed)",
    "kategorie": "Záda",
    "pohybVzor": "Tah horizontální",
    "svaly": "Záda, biceps",
    "vybaveni": "Kladka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 55,
    "nazev": "Veslování na stroji",
    "kategorie": "Záda",
    "pohybVzor": "Tah horizontální",
    "svaly": "Záda, biceps",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 56,
    "nazev": "Veslování s oporou hrudníku",
    "kategorie": "Záda",
    "pohybVzor": "Tah horizontální",
    "svaly": "Záda, zadní delty",
    "vybaveni": "Lavice / jednoručky",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 57,
    "nazev": "T-bar row",
    "kategorie": "Záda",
    "pohybVzor": "Tah horizontální",
    "svaly": "Záda, biceps",
    "vybaveni": "T-bar / osa",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 58,
    "nazev": "Inverted row (na hrazdě/TRX)",
    "kategorie": "Záda",
    "pohybVzor": "Tah horizontální",
    "svaly": "Záda, biceps",
    "vybaveni": "Hrazda / TRX",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 59,
    "nazev": "Veslování s gumou",
    "kategorie": "Záda",
    "pohybVzor": "Tah horizontální",
    "svaly": "Záda, biceps",
    "vybaveni": "Odporová guma",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 60,
    "nazev": "Stahy ramen (shrugs)",
    "kategorie": "Záda",
    "pohybVzor": "Izolace",
    "svaly": "Trapézy",
    "vybaveni": "Jednoručky / osa",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 61,
    "nazev": "Face pull",
    "kategorie": "Ramena",
    "pohybVzor": "Izolace",
    "svaly": "Zadní delty, trapézy",
    "vybaveni": "Kladka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 62,
    "nazev": "Rozpažky v předklonu (reverse fly)",
    "kategorie": "Ramena",
    "pohybVzor": "Izolace",
    "svaly": "Zadní delty",
    "vybaveni": "Jednoručky",
    "obtiznost": 1,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 63,
    "nazev": "Superman",
    "kategorie": "Záda",
    "pohybVzor": "Izolace",
    "svaly": "Vzpřimovače, hýždě",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 64,
    "nazev": "Y-T-W raises",
    "kategorie": "Záda",
    "pohybVzor": "Izolace",
    "svaly": "Dolní trapéz, zadní delty",
    "vybaveni": "Vlastní váha / jednoručky",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 65,
    "nazev": "Pull-apart s gumou",
    "kategorie": "Ramena",
    "pohybVzor": "Izolace",
    "svaly": "Zadní delty, trapézy",
    "vybaveni": "Odporová guma",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 66,
    "nazev": "Kliky (push-up)",
    "kategorie": "Hrudník",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Prsa, triceps, přední delty",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 67,
    "nazev": "Kliky na kolenou",
    "kategorie": "Hrudník",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Prsa, triceps",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 68,
    "nazev": "Kliky s nohama na lavici",
    "kategorie": "Hrudník",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Horní prsa, triceps",
    "vybaveni": "Lavice",
    "obtiznost": 3,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 69,
    "nazev": "Bench press (velká osa)",
    "kategorie": "Hrudník",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Prsa, triceps, přední delty",
    "vybaveni": "Velká osa / lavice",
    "obtiznost": 3,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 70,
    "nazev": "Bench press s jednoručkami",
    "kategorie": "Hrudník",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Prsa, triceps",
    "vybaveni": "Jednoručky / lavice",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 71,
    "nazev": "Šikmý bench s osou (incline)",
    "kategorie": "Hrudník",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Horní prsa, triceps",
    "vybaveni": "Velká osa / lavice",
    "obtiznost": 3,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 72,
    "nazev": "Šikmý bench s jednoručkami",
    "kategorie": "Hrudník",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Horní prsa, triceps",
    "vybaveni": "Jednoručky / lavice",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 73,
    "nazev": "Tlak na stroji (chest press)",
    "kategorie": "Hrudník",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Prsa, triceps",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 74,
    "nazev": "Pec deck (rozpažky na stroji)",
    "kategorie": "Hrudník",
    "pohybVzor": "Izolace",
    "svaly": "Prsa",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 75,
    "nazev": "Rozpažky s jednoručkami (fly)",
    "kategorie": "Hrudník",
    "pohybVzor": "Izolace",
    "svaly": "Prsa",
    "vybaveni": "Jednoručky / lavice",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 76,
    "nazev": "Rozpažky na kladkách (crossover)",
    "kategorie": "Hrudník",
    "pohybVzor": "Izolace",
    "svaly": "Prsa",
    "vybaveni": "Kladka",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 77,
    "nazev": "Dipy na bradlech (hrudník)",
    "kategorie": "Hrudník",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Prsa, triceps",
    "vybaveni": "Bradla",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 78,
    "nazev": "Tlak nad hlavu s jednoručkami",
    "kategorie": "Ramena",
    "pohybVzor": "Tlak vertikální",
    "svaly": "Delty, triceps",
    "vybaveni": "Jednoručky",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 79,
    "nazev": "Tlak nad hlavu s osou (military)",
    "kategorie": "Ramena",
    "pohybVzor": "Tlak vertikální",
    "svaly": "Delty, triceps, core",
    "vybaveni": "Velká osa",
    "obtiznost": 3,
    "bolestiZad": "Ne\r"
  },
  {
    "id": 80,
    "nazev": "Arnold press",
    "kategorie": "Ramena",
    "pohybVzor": "Tlak vertikální",
    "svaly": "Delty",
    "vybaveni": "Jednoručky",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 81,
    "nazev": "Tlak na stroji (shoulder press)",
    "kategorie": "Ramena",
    "pohybVzor": "Tlak vertikální",
    "svaly": "Delty, triceps",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 82,
    "nazev": "Upažování s jednoručkami (lateral raise)",
    "kategorie": "Ramena",
    "pohybVzor": "Izolace",
    "svaly": "Boční delty",
    "vybaveni": "Jednoručky",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 83,
    "nazev": "Upažování na kladce",
    "kategorie": "Ramena",
    "pohybVzor": "Izolace",
    "svaly": "Boční delty",
    "vybaveni": "Kladka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 84,
    "nazev": "Předpažování (front raise)",
    "kategorie": "Ramena",
    "pohybVzor": "Izolace",
    "svaly": "Přední delty",
    "vybaveni": "Jednoručky",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 85,
    "nazev": "Reverse pec deck",
    "kategorie": "Ramena",
    "pohybVzor": "Izolace",
    "svaly": "Zadní delty",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 86,
    "nazev": "Upright row (přítahy k bradě)",
    "kategorie": "Ramena",
    "pohybVzor": "Tah vertikální",
    "svaly": "Delty, trapézy",
    "vybaveni": "Osa / jednoručky",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 87,
    "nazev": "Tlak s gumou",
    "kategorie": "Ramena",
    "pohybVzor": "Tlak vertikální",
    "svaly": "Delty",
    "vybaveni": "Odporová guma",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 88,
    "nazev": "Bicepsový zdvih s osou",
    "kategorie": "Biceps",
    "pohybVzor": "Izolace",
    "svaly": "Biceps",
    "vybaveni": "Osa",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 89,
    "nazev": "Bicepsový zdvih s jednoručkami",
    "kategorie": "Biceps",
    "pohybVzor": "Izolace",
    "svaly": "Biceps",
    "vybaveni": "Jednoručky",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 90,
    "nazev": "Kladivový zdvih (hammer)",
    "kategorie": "Biceps",
    "pohybVzor": "Izolace",
    "svaly": "Biceps, předloktí",
    "vybaveni": "Jednoručky",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 91,
    "nazev": "Koncentrovaný zdvih",
    "kategorie": "Biceps",
    "pohybVzor": "Izolace",
    "svaly": "Biceps",
    "vybaveni": "Jednoručka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 92,
    "nazev": "Zdvih na Scottově lavici (preacher)",
    "kategorie": "Biceps",
    "pohybVzor": "Izolace",
    "svaly": "Biceps",
    "vybaveni": "Lavice / osa",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 93,
    "nazev": "Bicepsový zdvih na kladce",
    "kategorie": "Biceps",
    "pohybVzor": "Izolace",
    "svaly": "Biceps",
    "vybaveni": "Kladka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 94,
    "nazev": "Bicepsový zdvih s gumou",
    "kategorie": "Biceps",
    "pohybVzor": "Izolace",
    "svaly": "Biceps",
    "vybaveni": "Odporová guma",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 95,
    "nazev": "Incline dumbbell curl",
    "kategorie": "Biceps",
    "pohybVzor": "Izolace",
    "svaly": "Biceps",
    "vybaveni": "Jednoručky / lavice",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 96,
    "nazev": "Stahování kladky na triceps (pushdown)",
    "kategorie": "Triceps",
    "pohybVzor": "Izolace",
    "svaly": "Triceps",
    "vybaveni": "Kladka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 97,
    "nazev": "Francouzský tlak (skull crusher)",
    "kategorie": "Triceps",
    "pohybVzor": "Izolace",
    "svaly": "Triceps",
    "vybaveni": "Osa / jednoručky",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 98,
    "nazev": "Zákmihy v předklonu (kickback)",
    "kategorie": "Triceps",
    "pohybVzor": "Izolace",
    "svaly": "Triceps",
    "vybaveni": "Jednoručka",
    "obtiznost": 1,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 99,
    "nazev": "Tlak úzkým úchopem (close-grip)",
    "kategorie": "Triceps",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Triceps, prsa",
    "vybaveni": "Velká osa / lavice",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 100,
    "nazev": "Dipy na lavici (bench dips)",
    "kategorie": "Triceps",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Triceps",
    "vybaveni": "Lavice",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 101,
    "nazev": "Dipy na bradlech (triceps)",
    "kategorie": "Triceps",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Triceps",
    "vybaveni": "Bradla",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 102,
    "nazev": "Tricepsový tlak nad hlavu (jednoručka)",
    "kategorie": "Triceps",
    "pohybVzor": "Izolace",
    "svaly": "Triceps",
    "vybaveni": "Jednoručka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 103,
    "nazev": "Tricepsová extenze nad hlavu (kladka)",
    "kategorie": "Triceps",
    "pohybVzor": "Izolace",
    "svaly": "Triceps",
    "vybaveni": "Kladka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 104,
    "nazev": "Plank (prkno)",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Břicho, core",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 105,
    "nazev": "Boční plank (side plank)",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Šikmé břišní, core",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 106,
    "nazev": "Plank s přitahováním (shoulder tap)",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Břicho, core",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 107,
    "nazev": "Dead bug",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Hluboké břišní",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 108,
    "nazev": "Bird dog",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Core, vzpřimovače",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 109,
    "nazev": "Pallof press (anti-rotace)",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Core, šikmé břišní",
    "vybaveni": "Kladka / guma",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 110,
    "nazev": "Hollow hold",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Břicho",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 111,
    "nazev": "Farmer's carry (nošení břemen)",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Core, trapézy, předloktí",
    "vybaveni": "Jednoručky / kettlebell",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 112,
    "nazev": "Suitcase carry",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Šikmé břišní, core",
    "vybaveni": "Kettlebell / jednoručka",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 113,
    "nazev": "Crunch (zkracovačky)",
    "kategorie": "Core",
    "pohybVzor": "Core flexe",
    "svaly": "Přímý břišní",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 114,
    "nazev": "Crunch na stroji",
    "kategorie": "Core",
    "pohybVzor": "Core flexe",
    "svaly": "Přímý břišní",
    "vybaveni": "Stroj",
    "obtiznost": 1,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 115,
    "nazev": "Crunch na kladce (cable crunch)",
    "kategorie": "Core",
    "pohybVzor": "Core flexe",
    "svaly": "Přímý břišní",
    "vybaveni": "Kladka",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 116,
    "nazev": "Reverse crunch",
    "kategorie": "Core",
    "pohybVzor": "Core flexe",
    "svaly": "Dolní břišní",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 117,
    "nazev": "Přednožování vleže (leg raises)",
    "kategorie": "Core",
    "pohybVzor": "Core flexe",
    "svaly": "Dolní břišní",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 118,
    "nazev": "Přednožování ve visu (hanging leg raise)",
    "kategorie": "Core",
    "pohybVzor": "Core flexe",
    "svaly": "Dolní břišní",
    "vybaveni": "Hrazda",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 119,
    "nazev": "Přitahování kolen ve visu",
    "kategorie": "Core",
    "pohybVzor": "Core flexe",
    "svaly": "Dolní břišní",
    "vybaveni": "Hrazda",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 120,
    "nazev": "Russian twist",
    "kategorie": "Core",
    "pohybVzor": "Rotace",
    "svaly": "Šikmé břišní",
    "vybaveni": "Vlastní váha / medicinbal",
    "obtiznost": 2,
    "bolestiZad": "Ne\r"
  },
  {
    "id": 121,
    "nazev": "Bicycle crunch",
    "kategorie": "Core",
    "pohybVzor": "Rotace",
    "svaly": "Šikmé břišní",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 122,
    "nazev": "Wood chop (dřevorubec)",
    "kategorie": "Core",
    "pohybVzor": "Rotace",
    "svaly": "Šikmé břišní, core",
    "vybaveni": "Kladka / medicinbal",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 123,
    "nazev": "Ab wheel (kolečko)",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Břicho, core",
    "vybaveni": "Ab wheel",
    "obtiznost": 3,
    "bolestiZad": "Ne\r"
  },
  {
    "id": 124,
    "nazev": "V-ups",
    "kategorie": "Core",
    "pohybVzor": "Core flexe",
    "svaly": "Břicho",
    "vybaveni": "Vlastní váha",
    "obtiznost": 3,
    "bolestiZad": "Ne\r"
  },
  {
    "id": 125,
    "nazev": "Mountain climbers",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Core, kardio",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 126,
    "nazev": "Copenhagen plank",
    "kategorie": "Core",
    "pohybVzor": "Core stabilizace",
    "svaly": "Adduktory, core",
    "vybaveni": "Vlastní váha / lavice",
    "obtiznost": 3,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 127,
    "nazev": "Běžecký pás (chůze)",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Kardiovaskulární systém",
    "vybaveni": "Běžecký pás",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 128,
    "nazev": "Běžecký pás (běh)",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Kardiovaskulární systém",
    "vybaveni": "Běžecký pás",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 129,
    "nazev": "Eliptický trenažér",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Kardiovaskulární systém",
    "vybaveni": "Eliptical",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 130,
    "nazev": "Rotoped / kolo",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Kardiovaskulární systém",
    "vybaveni": "Rotoped",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 131,
    "nazev": "Veslařský trenažér",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Kardiovaskulární systém, záda",
    "vybaveni": "Veslařský trenažér",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 132,
    "nazev": "Schodišťový trenažér (stairmaster)",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Kardiovaskulární systém, hýždě",
    "vybaveni": "Stairmaster",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 133,
    "nazev": "Air bike (assault bike)",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Kardiovaskulární systém",
    "vybaveni": "Air bike",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 134,
    "nazev": "Skákání přes švihadlo",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Kardiovaskulární systém, lýtka",
    "vybaveni": "Švihadlo",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 135,
    "nazev": "Battle ropes (lana)",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Kardiovaskulární systém, ramena",
    "vybaveni": "Battle ropes",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 136,
    "nazev": "Burpees",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Celé tělo",
    "vybaveni": "Vlastní váha",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 137,
    "nazev": "Jumping jacks",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Celé tělo",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 138,
    "nazev": "High knees",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Celé tělo, kardio",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 139,
    "nazev": "Tlačení saní (prowler/sled)",
    "kategorie": "Kardio",
    "pohybVzor": "Kardio",
    "svaly": "Celé tělo",
    "vybaveni": "Saně",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 140,
    "nazev": "TRX dřep",
    "kategorie": "Komplexní",
    "pohybVzor": "Dřep",
    "svaly": "Kvadricepsy, hýždě, core",
    "vybaveni": "TRX",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 141,
    "nazev": "TRX veslování",
    "kategorie": "Komplexní",
    "pohybVzor": "Tah horizontální",
    "svaly": "Záda, biceps, core",
    "vybaveni": "TRX",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 142,
    "nazev": "TRX kliky",
    "kategorie": "Komplexní",
    "pohybVzor": "Tlak horizontální",
    "svaly": "Prsa, triceps, core",
    "vybaveni": "TRX",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 143,
    "nazev": "TRX výpady",
    "kategorie": "Komplexní",
    "pohybVzor": "Výpad",
    "svaly": "Kvadricepsy, hýždě, core",
    "vybaveni": "TRX",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 144,
    "nazev": "Turkish get-up",
    "kategorie": "Komplexní",
    "pohybVzor": "Core stabilizace",
    "svaly": "Celé tělo, stabilizace",
    "vybaveni": "Kettlebell",
    "obtiznost": 3,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 145,
    "nazev": "Medicinbal slam",
    "kategorie": "Komplexní",
    "pohybVzor": "Rotace",
    "svaly": "Core, ramena",
    "vybaveni": "Medicinbal",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 146,
    "nazev": "Medicinbal rotace o stěnu",
    "kategorie": "Komplexní",
    "pohybVzor": "Rotace",
    "svaly": "Šikmé břišní, core",
    "vybaveni": "Medicinbal",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 147,
    "nazev": "Wall ball",
    "kategorie": "Komplexní",
    "pohybVzor": "Dřep",
    "svaly": "Nohy, ramena, core",
    "vybaveni": "Medicinbal",
    "obtiznost": 2,
    "bolestiZad": "S omezením\r"
  },
  {
    "id": 148,
    "nazev": "Box jump (výskok na bednu)",
    "kategorie": "Komplexní",
    "pohybVzor": "Dřep",
    "svaly": "Nohy, výbušnost",
    "vybaveni": "Bedna",
    "obtiznost": 3,
    "bolestiZad": "Ne\r"
  },
  {
    "id": 149,
    "nazev": "Balance na Bosu",
    "kategorie": "Komplexní",
    "pohybVzor": "Core stabilizace",
    "svaly": "Stabilizace, core",
    "vybaveni": "Bosu",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 150,
    "nazev": "Stoj na jedné noze (balance)",
    "kategorie": "Komplexní",
    "pohybVzor": "Core stabilizace",
    "svaly": "Stabilizace kotníku/kyčle",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 151,
    "nazev": "Kočka-velbloud (cat-cow)",
    "kategorie": "Mobilita",
    "pohybVzor": "Mobilita",
    "svaly": "Páteř",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 152,
    "nazev": "Rotace hrudní páteře (thoracic rotation)",
    "kategorie": "Mobilita",
    "pohybVzor": "Mobilita",
    "svaly": "Hrudní páteř",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 153,
    "nazev": "Kroužení kyčlí (hip circles)",
    "kategorie": "Mobilita",
    "pohybVzor": "Mobilita",
    "svaly": "Kyčle",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 154,
    "nazev": "Kroužení rameny (arm circles)",
    "kategorie": "Mobilita",
    "pohybVzor": "Mobilita",
    "svaly": "Ramena",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 155,
    "nazev": "Švihy nohou (leg swings)",
    "kategorie": "Mobilita",
    "pohybVzor": "Mobilita",
    "svaly": "Kyčle, hamstringy",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 156,
    "nazev": "World's greatest stretch",
    "kategorie": "Mobilita",
    "pohybVzor": "Mobilita",
    "svaly": "Kyčle, hrudní páteř",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 157,
    "nazev": "90/90 mobilita kyčlí",
    "kategorie": "Mobilita",
    "pohybVzor": "Mobilita",
    "svaly": "Kyčle",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 158,
    "nazev": "Mobilita kotníků",
    "kategorie": "Mobilita",
    "pohybVzor": "Mobilita",
    "svaly": "Kotníky",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 159,
    "nazev": "Foam rolling (pěnový válec)",
    "kategorie": "Mobilita",
    "pohybVzor": "Mobilita",
    "svaly": "Měkké tkáně",
    "vybaveni": "Pěnový válec",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 160,
    "nazev": "Wall angels",
    "kategorie": "Mobilita",
    "pohybVzor": "Mobilita",
    "svaly": "Ramena, hrudní páteř",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 161,
    "nazev": "Poloha dítěte (child's pose)",
    "kategorie": "Mobilita",
    "pohybVzor": "Mobilita",
    "svaly": "Záda, kyčle",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 162,
    "nazev": "McGill curl-up",
    "kategorie": "Rehabilitace",
    "pohybVzor": "Core stabilizace",
    "svaly": "Břicho (šetrné k páteři)",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 163,
    "nazev": "Side bridge (McGill)",
    "kategorie": "Rehabilitace",
    "pohybVzor": "Core stabilizace",
    "svaly": "Šikmé břišní, core",
    "vybaveni": "Vlastní váha",
    "obtiznost": 2,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 164,
    "nazev": "Bird dog (rehab)",
    "kategorie": "Rehabilitace",
    "pohybVzor": "Core stabilizace",
    "svaly": "Core, vzpřimovače",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 165,
    "nazev": "Sciatic nerve slider (neurodynamika)",
    "kategorie": "Rehabilitace",
    "pohybVzor": "Mobilita",
    "svaly": "Sedací nerv (klouzání)",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 166,
    "nazev": "Pelvic tilt (naklápění pánve)",
    "kategorie": "Rehabilitace",
    "pohybVzor": "Mobilita",
    "svaly": "Hluboké břišní, pánev",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 167,
    "nazev": "Glute bridge (rehab)",
    "kategorie": "Rehabilitace",
    "pohybVzor": "Hip hinge",
    "svaly": "Hýždě",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 168,
    "nazev": "Clamshell s gumou (rehab)",
    "kategorie": "Rehabilitace",
    "pohybVzor": "Izolace",
    "svaly": "Hýždě (m. gluteus medius)",
    "vybaveni": "Odporová guma",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  },
  {
    "id": 169,
    "nazev": "Dead bug (rehab)",
    "kategorie": "Rehabilitace",
    "pohybVzor": "Core stabilizace",
    "svaly": "Hluboké břišní",
    "vybaveni": "Vlastní váha",
    "obtiznost": 1,
    "bolestiZad": "Ano\r"
  }
];

// Kategorie pro filter (pre-počítaný unique set seřazený)
export const CVIKY_KATEGORIE = ["Biceps","Core","Dolní končetiny","Hrudník","Hýždě","Kardio","Komplexní","Lýtka","Mobilita","Ramena","Rehabilitace","Triceps","Záda"];

// Search helper - case + diakritika insensitive.
function norm(s) { return String(s||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }
export function searchCviky(query, limit = 30) {
  const q = norm(query).trim();
  if (!q) return [];
  const matches = [];
  for (const c of CVIKY_DATABAZE) {
    const haystack = norm(c.nazev + " " + c.kategorie + " " + c.svaly + " " + c.vybaveni);
    if (haystack.includes(q)) {
      matches.push(c);
      if (matches.length >= limit) break;
    }
  }
  return matches;
}

// Lookup by ID (pro detail)
export function getCvikById(id) {
  return CVIKY_DATABAZE.find(c => c.id === Number(id)) || null;
}
